import { EventEmitter } from "events"
import dispatcher from "../dispatcher"
import { ILeaveTrackingStateFilter, IDateRange } from "../models"
import moment from "moment"
class LeaveTrackingStore extends EventEmitter {
  stateFilter: ILeaveTrackingStateFilter = {
    Requested: true,
    Approved: true,
    Denied: true
  }
  dateFilter: IDateRange = {
    StartDate: moment().utc(true).startOf("year").format(),
    EndDate: moment().utc(true).endOf("year").format(),
  }
  searchText: string = ""
  limit: number = 20
  offset: number = 0
  limitOption: number[] = [20, 50, 100]
  constructor() {
    super()
    this.setMaxListeners(0)
  }

  setStateFilter(data: ILeaveTrackingStateFilter) {
    this.stateFilter = data
    this.offset = 0
    this.emit("change")
  }

  getStateFilter(): ILeaveTrackingStateFilter {
    return this.stateFilter
  }

  setDateFilter(data: IDateRange) {
    this.dateFilter = data
    this.offset = 0
    this.emit("change")
  }

  getDateFilter(): IDateRange {
    return this.dateFilter
  }

  setOffset(offset) {
    this.offset = offset
    this.emit("change")
  }

  getOffset(): number {
    return this.offset
  }

  setLimit(limit) {
    this.limit = limit
    this.offset = 0
    this.emit("change")
  }

  getLimit(): number {
    return this.limit
  }

  getLimitOption(): number[] {
    return this.limitOption
  }

  setSearchText(searchText) {
    this.searchText = searchText
    this.offset = 0
    this.emit("change")
  }

  getSearchText(): string {
    return this.searchText
  }

  initOffsetSearch() {
    this.offset = 0
    this.searchText = ""
    this.emit("change")
  }

  handleActions(action) {
    switch (action.type) {
      case "UPDATE_LEAVE_TRACKING_STATE_FILTER": {
        this.setStateFilter(action.data)
        break
      }
      case "UPDATE_LEAVE_TRACKING_DATE_FILTER": {
        this.setDateFilter(action.data)
        break
      }
      case "UPDATE_LEAVE_TRACKING_OFFSET": {
        this.setOffset(action.data)
        break
      }
      case "UPDATE_LEAVE_TRACKING_LIMIT": {
        this.setLimit(action.data)
        break
      }
      case "UPDATE_LEAVE_TRACKING_SEARCH": {
        this.setSearchText(action.data)
        break
      }
      case "INIT_LEAVE_TRACKING_OFFSET_SEARCH": {
        this.initOffsetSearch()
        break
      }
    }
  }
}

const leaveTrackingStore = new LeaveTrackingStore()
dispatcher.register(leaveTrackingStore.handleActions.bind(leaveTrackingStore))

export default leaveTrackingStore